// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3051":"00c9907092748af5","8136":"b1f38092ed547b22"}[chunkId] + ".css";
};